import { SubscriptionPlan, SubscriptionPlanTier } from "@apaq/orgkit-js";

export class SubscriptionPlanCalculator {

    public static calculatePrice(plan: SubscriptionPlan, numberOfAccounts: number) {
        if(plan.tiers == null) {
            return plan.price * numberOfAccounts;
        } else {
            let amount = 0;
            for(let i=1;i<=numberOfAccounts;i++) {
                let tier = this.getTier(plan.tiers, i);
                if(tier != null) {
                    amount += tier.amount;
                }
            }
            return amount;
        }
    }

    private static getTier(tiers: SubscriptionPlanTier[], upTo: number): SubscriptionPlanTier | undefined {
        let lowestUpTo = Number.MAX_VALUE;
        let tier;
        tiers.forEach(t => {
            let currentUpTo = t.upTo == null ? Number.MAX_VALUE : t.upTo;
            if(currentUpTo >= upTo && currentUpTo <= lowestUpTo) {
                lowestUpTo = currentUpTo;
                tier = t;
            }

        });
        return tier;
    }
}